import { useLogin } from "@refinedev/core";
import { GoogleLogin, type CredentialResponse } from "@react-oauth/google";
import { Card, Divider, Layout, Space, Typography } from "antd";
import { useSearchParams } from "react-router";

const { Title, Text } = Typography;

export const Login: React.FC = () => {
  const { mutate: login } = useLogin();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo") ?? undefined;

  const handleGoogleSuccess = (response: CredentialResponse) => {
    if (response.credential) {
      login({ idToken: response.credential, returnTo });
    }
  };

  return (
    <Layout
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
      }}
    >
      <Card style={{ width: 360, textAlign: "center" }}>
        <Space vertical size="large" style={{ width: "100%" }}>
          <div>
            <Title level={3} style={{ margin: 0 }}>
              Loopress Console
            </Title>
            <Text type="secondary">Loopress</Text>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => undefined}
              useOneTap={false}
              shape="rectangular"
              size="large"
              width={280}
            />
          </div>

          {import.meta.env.DEV && (
            <>
              <Divider plain>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  dev only
                </Text>
              </Divider>
              <button
                style={{
                  width: "100%",
                  padding: "6px 0",
                  cursor: "pointer",
                  border: "1px dashed #d9d9d9",
                  borderRadius: 4,
                  background: "transparent",
                  color: "#8c8c8c",
                  fontSize: 13,
                }}
                onClick={() => login({ returnTo })}
              >
                Dev login (mock)
              </button>
            </>
          )}

          <Text type="secondary" style={{ fontSize: 12 }}>
            For authorized developers only
          </Text>
        </Space>
      </Card>
    </Layout>
  );
};
